(function () {
  'use strict';

  function refreshMinimogCart(openDrawer) {
    // Minimog's own cart.js listens for this event on <m-cart-items> and
    // re-renders the m-cart-count bubble (and cart drawer contents) for us.
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { open: !!openDrawer }
      })
    );
  }

  function formatMoney(cents) {
    // Basic fallback formatter — replace with Shopify.formatMoney if the theme
    // already loads money_format from settings, for full currency support.
    return '$' + (cents / 100).toFixed(2);
  }

  function initCard(card) {
    var select = card.querySelector('[data-variant-select]');
    var priceDisplay = card.querySelector('[data-price-display]');
    var addBtn = card.querySelector('[data-add-to-cart]');

    if (!select || !addBtn) return;

    // Update price when a variant/size is selected
    select.addEventListener('change', function () {
      var selectedOption = select.options[select.selectedIndex];
      var price = selectedOption ? selectedOption.getAttribute('data-price') : null;
      if (price && priceDisplay) {
        priceDisplay.textContent = formatMoney(parseInt(price, 10));
      }
      addBtn.disabled = !select.value;
    });

    // Add to cart
    addBtn.addEventListener('click', function () {
      var variantId = select.value;

      if (!variantId) {
        select.focus();
        return;
      }

      addBtn.disabled = true;
      var originalLabel = addBtn.textContent;
      addBtn.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          addBtn.textContent = 'ADDED';

          // Refresh Minimog's cart count bubble + open the cart drawer
          refreshMinimogCart(true);

          document.dispatchEvent(new CustomEvent('cart:updated'));

          setTimeout(function () {
            addBtn.textContent = originalLabel;
            addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          addBtn.textContent = 'ERROR — TRY AGAIN';
          setTimeout(function () {
            addBtn.textContent = originalLabel;
            addBtn.disabled = false;
          }, 1800);
        });
    });

    // Touch/mobile support — tap image to reveal quick-add panel
    var imageLink = card.querySelector('.product-grid__image-link');
    var isTouch = window.matchMedia('(hover: none)').matches;

    if (isTouch && imageLink) {
      imageLink.addEventListener('click', function (e) {
        if (!card.classList.contains('is-active')) {
          e.preventDefault();
          document
            .querySelectorAll('.product-grid__card.is-active')
            .forEach(function (openCard) {
              if (openCard !== card) openCard.classList.remove('is-active');
            });
          card.classList.add('is-active');
        }
      });

      document.addEventListener('click', function (e) {
        if (!card.contains(e.target)) {
          card.classList.remove('is-active');
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-product-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();